"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _fr = _interopRequireDefault(require("date-fns/locale/fr"));

var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));

var _excluded = ["id", "name", "value", "label", "placeholder", "helper", "floatLabel", "clearable", "locale", "withIcon", "calendarOnly", "readOnly", "disabled", "required", "onChange", "onBlur", "onError", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

(0, _reactDatepicker.registerLocale)('fr', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-FR', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-CA', _fr.default);

var isValidDate = function isValidDate(date) {
  // eslint-disable-next-line no-restricted-globals
  return date instanceof Date || typeof date === 'number' && date.toString().length <= 10;
};

var prepareInput = function prepareInput(date) {
  if (date && typeof date === 'number') {
    if (isValidDate(date)) {
      // It's a UNIX Timestamp
      return new Date(date * 1000);
    } // It's a JS Timestamp


    return new Date(date);
  }

  if (date && (date instanceof Date || new Date(date) instanceof Date)) {
    return new Date(date);
  }

  return null;
};

var prepareOutput = function prepareOutput(date, dateRef) {
  if (dateRef && typeof dateRef === 'number') {
    if (isValidDate(dateRef)) {
      // As we get an UNIX Timestamp as input, we output an UNIX Timestamp too
      return Date.parse(date) / 1000;
    } // As we get a JS Timestamp as input, we output a JS Timestamp too


    return new Date(date).getTime();
  }

  if (dateRef && (dateRef instanceof Date || new Date(dateRef) instanceof Date)) {
    // Otherwise we output a JS Date
    return new Date(date);
  }

  return Date.parse(date) / 1000;
};
/**
 * The DatePicker component allows an user to select a date and/or time in a determined format.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/Hacker0x01/react-datepicker/">React Datepicker</a>
 */


var DateSelector = function DateSelector(_ref) {
  var controlledId = _ref.id,
      name = _ref.name,
      controlledDate = _ref.value,
      initialLabel = _ref.label,
      placeholder = _ref.placeholder,
      helper = _ref.helper,
      floatLabel = _ref.floatLabel,
      clearable = _ref.clearable,
      locale = _ref.locale,
      withIcon = _ref.withIcon,
      calendarOnly = _ref.calendarOnly,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      required = _ref.required,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onError = _ref.onError,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var datePickerRef = _react.default.useRef(null);

  var id = (0, _useRandomId.default)(controlledId);

  var _React$useState = _react.default.useState(prepareInput(controlledDate)),
      date = _React$useState[0],
      setDate = _React$useState[1];

  var labelClasses = (0, _clsx.default)(initialLabel && floatLabel ? 'float-label' : false, floatLabel && (date || placeholder) ? 'filled' : false);

  var _useLabel = (0, _useLabel2.default)(initialLabel, id, labelClasses, required),
      label = _useLabel.label;

  var _React$useState2 = _react.default.useState(false),
      error = _React$useState2[0],
      setError = _React$useState2[1]; // const [calOnly, setCalOnly] = React.useState(false);


  var _useFormElementValida = (0, _useFormElementValidation.default)(date, {
    required: required,
    date: date
  }),
      errors = _useFormElementValida[0],
      methods = _useFormElementValida[1];

  _react.default.useEffect(function () {
    return setDate(prepareInput(controlledDate));
  }, [controlledDate]); // React.useEffect(() => setCalOnly(calendarOnly), [calendarOnly]);


  _react.default.useEffect(function () {
    setError(errors.length > 0);

    if (typeof onError === 'function') {
      onError({
        name: datePickerRef.current.props.name,
        errors: errors.length ? errors : []
      });
    }
  }, [errors, onError]); // const DatePickerInput = React.forwardRef((props, ref) => {
  //     console.log(props);
  //     return <Input {...props} ref={ref} readOnly={calOnly} />;
  // });


  var handleChange = function handleChange(updatedDate) {
    console.log(updatedDate);
    var po = prepareOutput(updatedDate, controlledDate);
    setDate(updatedDate);

    if (typeof onChange === 'function') {
      onChange(po, datePickerRef.current.props.name);
    }
  };

  var handleOnClear = function handleOnClear() {
    // similar to handleChange
    methods.onChangeDate(null);
    setDate(null);

    if (typeof onChange === 'function') {
      onChange(null, datePickerRef.current.props.name);
    }
  };

  var handleBlur = function handleBlur(event) {
    datePickerRef.current.setOpen(false);
    console.log('date', date);
    methods.onChangeDate(date);

    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  };

  var handleFocus = function handleFocus() {
    if (!date) {
      var today = Date.now();
      console.log(today);
      handleChange(new Date(today));
    }
  };

  var handleClickOutside = function handleClickOutside() {
    datePickerRef.current.setOpen(false);
  };

  var containerClasses = (0, _clsx.default)('uk-input', 'uk-datepicker', helper.length > 0 || error ? 'has-helper' : '', error ? 'has-error' : '', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    ref: datePickerRef,
    id: id,
    name: name || id,
    selected: date || null,
    placeholderText: placeholder,
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onFocus: handleFocus,
    onChange: handleChange,
    onClickOutside: handleClickOutside,
    onBlur: handleBlur,
    tabIndex: 0,
    popperPlacement: "bottom-end" // customInput={<DatePickerInput />}
    ,
    locale: locale ? locale.split('-')[0] : null,
    dateFormat: locale && locale.split('-')[0] === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'
  }, attributes)), withIcon && (!clearable || !date) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "calendar"
  }), clearable && date && /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": "true",
    className: "uk-input__clearButton",
    onClick: handleOnClear
  }, "\xD7"), (helper.length > 0 || error) && /*#__PURE__*/_react.default.createElement("small", {
    className: "helper"
  }, error ? errors : helper));
};

DateSelector.propTypes = {
  /**
   * ID of the DatePicker (used to bind the label to its input field)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,

  /**
   * Name of the DatePicker (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,

  /**
   * Default value of the DatePicker
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]),

  /**
   * Label of the DatePicker
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * DatePicker placeholder
   */
  placeholder: _propTypes.default.string,

  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,

  /**
   * Remove the placeholder (if any), replace it with a floating label
   */
  floatLabel: _propTypes.default.bool,

  /**
   * TODO
   * Set the date formatting depending on the locale
   * (e.g. 'en', 'en-CA', 'en_CA', etc.)
   */
  locale: _propTypes.default.oneOf(['en', 'fr']),

  /**
   * Add a decorative calendar icon to the DatePicker
   */
  withIcon: _propTypes.default.bool,

  /**
   * Add a button to clear the DatePicker
   */
  clearable: _propTypes.default.bool,

  /**
   * Set the DatePicker as read-only
   */
  calendarOnly: _propTypes.default.bool,

  /**
   * Set the DatePicker as read-only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Set the DatePicker as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Form-validation: set the DatePicker as required
   */
  required: _propTypes.default.bool,

  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function onError
   */
  onError: _propTypes.default.func
};
DateSelector.defaultProps = {
  placeholder: '',
  helper: '',
  floatLabel: false,
  withIcon: true,
  calendarOnly: false,
  readOnly: false,
  disabled: false,
  required: false,
  clearable: false
};
DateSelector.displayName = 'DatePicker';
var _default = DateSelector;
exports.default = _default;